<main>
  <header class="flex items-center justify-between bg-black/90 border-b border-gray-200 py-2">
    <!-- Left: Logo -->
    <div class="flex items-center space-x-2 cursor-pointer" (click)="logoClickEvent()">
      <a class="flex items-center">
        <svg
          height="40"
          width="40"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 300 300"
        >
          <ellipse
            rx="54.514671"
            ry="58.577877"
            transform="matrix(1.32298 0 0 1.265902 150 150)"
            fill="none"
            stroke="#6366f1"
            stroke-width="25"
          />
          <ellipse
            rx="30"
            ry="30"
            transform="matrix(.778782 0 0 0.826184 120.626156 125.21448)"
            fill="#6366f1"
          />
        </svg>
        <span class="text-xl font-semibold text-white">WebWatch</span>
      </a>
    </div>
    <div class="relative w-[40rem] max-w-3xl">

      <div class="absolute inset-y-0 left-2 flex items-center">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6  text-gray-400" fill="none"
             viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M21 21l-4.35-4.35M17 11a6 6 0 11-12 0 6 6 0 0112 0z" />
        </svg>
      </div>

      <input
        #globalSearchInput
        pInputText
        (keydown)="onKeyDown($event)"
        (focus)="onFocus()"
        [placeholder]="isMac() ? 'Search... Press ^ + Space ' : 'Press Control + Space'"
        type="search"
        class="w-full pl-10 h-3rem rounded-xl shadow-sm border border-gray-300 text-gray-700 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-cyan-500 focus:border-cyan-500 transition duration-200 text-base"
        [formControl]="globalSearchControl"
      />
      @if (searchResults) {
        <div
          #searchResultsContainer
          class="absolute w-full mt-2 bg-white rounded-lg shadow-lg z-60"
          [class.hidden]="searchResults.length === 0"
          (mousedown)="preventClose($event)"
        >
          <div class="overflow-auto h-[20rem]">
            <p-tabView>
              <!-- Monitors Tab -->
              <p-tabPanel>
                <ng-template pTemplate="header">
                  <span class="flex text-sm items-center">
                    Monitors
                    <p-badge
                      badgeSize="small"
                      [value]="monitors?.length || 0"
                      severity="info"
                      class="ml-2"
                    ></p-badge>
                  </span>
                </ng-template>
                @for (result of monitors; track result.id) {
                  <div
                    class="p-3 hover:bg-gray-100 cursor-pointer border-b border-gray-200 transition-colors duration-150"
                    (click)="selectResult(result)"
                    (keydown)="$event.key === 'Enter' ? selectResult(result) : null"
                    tabindex="0"
                    [class.bg-blue-50]="selectedResult?.id === result.id"
                  >
                    <div class="flex items-center justify-between">
                      <div>
                        <div class="text-sm">{{ result.name }}</div>
                        <div class="text-xs text-gray-600">
                          {{ getEntityTypeLabel(result.type) }}
                        </div>
                      </div>
                    </div>
                  </div>
                }
                @if (monitors?.length === 0) {
                  <div class="p-3 text-sm text-gray-500">No monitors found</div>
                }
              </p-tabPanel>

              <!-- Projects Tab -->
              <p-tabPanel>
                <ng-template pTemplate="header">
                  <span class="flex text-sm items-center">
                    Projects
                    <p-badge
                      badgeSize="small"
                      [value]="projects?.length || 0"
                      severity="info"
                      class="ml-2"
                    ></p-badge>
                  </span>
                </ng-template>
                @for (result of projects; track result.id) {
                  <div
                    class="p-3 hover:bg-gray-100 cursor-pointer border-b border-gray-200 transition-colors duration-150"
                    (click)="selectResult(result)"
                    (keydown)="$event.key === 'Enter' ? selectResult(result) : null"
                    tabindex="0"
                    [class.bg-blue-50]="selectedResult?.id === result.id"
                  >
                    <div class="flex items-center justify-between">
                      <div>
                        <div class="text-sm">{{ result.name }}</div>
                        <div class="text-xs text-gray-600">
                          {{ getEntityTypeLabel(result.type) }}
                        </div>
                      </div>
                    </div>
                  </div>
                }
                @if (projects?.length === 0) {
                  <div class="p-3 text-sm text-gray-500">No projects found</div>
                }
              </p-tabPanel>
            </p-tabView>
          </div>
        </div>
      }
      @if (searchResults?.length === 0) {
        <div class="absolute w-full mt-2 p-4 bg-white rounded-lg shadow-lg flex items-center">
          <i class="pi pi-info-circle text-gray-500 mr-2"></i>
          <span class="text-gray-600">No matching entities found. Try different keywords.</span>
        </div>
      }
    </div>

    <!-- Right: User Info -->
    <div class="flex items-center space-x-1 ">
      <p-tieredMenu #menu [model]="items" [popup]="true" appendTo="body"></p-tieredMenu>
      <button
        pButton
        type="button"
        (click)="menu.toggle($event)"
        class="user-initials border-none"
      >
        @if (userDetail?.img) {
          <p-avatar
            [image]="userDetail?.img"
            shape="circle"
          ></p-avatar>
        } @else {
          <p-avatar
            label="{{userDetail?.name[0]}}"
            shape="circle"
          ></p-avatar>
        }
      </button>
      <span class="font-bold  text-white mr-2">{{ userDetail?.name }}</span>
    </div>
  </header>

  <nav class="sticky opacity-100  top-[0px] z-50 px-2 py-1 bg-gray-100 border-b border-gray-200">
    <app-breadcrumb></app-breadcrumb>
  </nav>

  <section class="flex w-full py-4">
    <!-- Sidebar -->
    <div class="transition-all duration-300 bg-white min-h-screen m-2"
         [ngClass]="sidebarVisible ? 'w-[20%] px-3' : 'w-[0%] opacity-0'">
      <app-sidebar></app-sidebar>
    </div>



    <!-- Main content -->
    <section class="pr-3 transition-all duration-300"
             [ngClass]="sidebarVisible ? ' w-[80%]' : 'w-[100%] pl-3'"
    >
      <router-outlet></router-outlet>
    </section>
  </section>

</main>
